import { createReducer } from '@reduxjs/toolkit';
import { addNewKyp, setHasError, setIsLoading, setKyps, setKypSortBy, setKypSortingDate, setSelectedKyp } from 'data/actions/KYP';
import { Kyp, KypDateField, KypSortOption } from 'data/models/Kyp';

export interface State {
  kyps: Kyp[];
  selectedKyp: Kyp | undefined;
  sortBy: KypSortOption | undefined;
  sortingDate: KypDateField | undefined;
  isLoading: boolean;
  hasError: boolean;
}

export const initialState: State = {
  kyps: [],
  selectedKyp: undefined,
  sortBy: undefined,
  sortingDate: undefined,
  isLoading: false,
  hasError: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(setKyps, (state, action) => ({
    ...state,
    kyps: action.payload,
  }));

  builder.addCase(addNewKyp, (state, action) => {
    const newKyps: Kyp[] = state.kyps.map(k => ({ ...k }));
    newKyps.push(action.payload);

    return { ...state, kyps: newKyps };
  });

  builder.addCase(setSelectedKyp, (state, action) => ({
    ...state,
    selectedKyp: action.payload,
  }));

  builder.addCase(setIsLoading, (state, action) => ({
    ...state,
    isLoading: action.payload,
  }));

  builder.addCase(setHasError, (state, action) => ({
    ...state,
    hasError: action.payload,
  }));

  builder.addCase(setKypSortBy, (state, action) => ({
    ...state,
    sortBy: action.payload,
  }));

  builder.addCase(setKypSortingDate, (state, action) => ({
    ...state,
    sortingDate: action.payload,
  }));
});
